import { notNil } from './notNil';

type TestIdPart = string | number | undefined | null;

export function getTestId(...parts: TestIdPart[]) {
  return parts.filter(notNil).join('-').replace(/[& ]/g, '-');
}
